<template>
  <div class="tabs is-boxed">
    <ul>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.brands.edit', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Main page</span>
          </a>
        </li>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.brands.edit.products', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Products page</span>
          </a>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uuid: this.$route.params.uuid,
    };
  },
};
</script>
